export default {"src":"/_next/static/media/motus_logo.4ee1f7dc.svg","height":145,"width":279,"blurWidth":0,"blurHeight":0};